import Swiper from 'swiper';
import 'swiper/css';
import { Navigation } from 'swiper/modules';

const helpers = window.BASE_HELPERS || {};
const { Mobile } = helpers;

const MODULE = document.querySelectorAll('[data-module="galeria"]');

class Galeria {
    constructor() {
        this.components = MODULE;
        this.init();
    }

    init() {
        this.components.forEach(component => {
            const swiperGallery = component.querySelector('.swiper-gallery');
            if (swiperGallery) this.initSwiperGallery(swiperGallery);

            const swiperModal = component.querySelector('.swiper-modal');
            if (swiperModal) this.initSwiperModal(swiperModal);

            console.log(swiperGallery);
            console.log(swiperModal);
        });
    }

    initSwiperGallery(swiperComponent) {
        new Swiper(swiperComponent, {
            modules: [Navigation],
            loop: true,
            slidesPerView: 'auto',
            spaceBetween: 22,
            centeredSlides: true,
            breakpoints: {
                1260: {
                    slidesPerView: 6,
                    centeredSlides: false,
                }
            },
            navigation: {
                nextEl: swiperComponent.querySelector('.swiper-button-next'),
                prevEl: swiperComponent.querySelector('.swiper-button-prev'),
            },
            on: {
                afterInit: (swiper) => {
                    if (Mobile.isMobile()) {
                        swiper.el.querySelector('.pagination').classList.add('active');
                    }

                    if (!Mobile.isMobile() && swiper.slides.length > 6) {
                        swiper.el.querySelector('.pagination').classList.add('active');
                    }
                }
            }
        });
    }

    initSwiperModal(swiperComponent) {
        new Swiper(swiperComponent, {
            modules: [Navigation],
            loop: true,
            slidesPerView: 'auto',
            spaceBetween: 22,
            autoHeight: true,
            navigation: {
                nextEl: swiperComponent.querySelector('.swiper-button-next'),
                prevEl: swiperComponent.querySelector('.swiper-button-prev'),
            },
            on: {
                afterInit: (swiper) => {
                    if (Mobile.isMobile() && swiper.slides.length > 1) {
                        swiper.el.querySelector('.pagination').classList.add('active');
                    }

                    if (!Mobile.isMobile() && swiper.slides.length > 6) {
                        swiper.el.querySelector('.pagination').classList.add('active');
                    }
                }
            }
        });
    }
}

(() => {
    if (MODULE) {
        new Galeria();
    }
})();

export default Galeria;
